import { createFileRoute, redirect } from "@tanstack/react-router";

import { followUserLocale, meQuery } from "../app/me";
import { AppShell } from "../features/shell/app-shell";
import { PageLoading } from "../features/shell/status-pages";

/**
 * Everything behind sign-in. After a reload there is no token in memory: one refresh (cookie) restores the
 * session, or the user goes to sign-in and comes back to the same page afterwards.
 */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    if (context.session.token() !== undefined) return;
    const restored = await context.api.refresh().catch(() => undefined);
    if (restored === undefined) throw redirect({ to: "/sign-in", search: { next: location.href } });
  },
  loader: async ({ context }) => {
    // No silent retries here: a failure shows the error page with its own "Try again" at once.
    const me = await context.queryClient.query({ ...meQuery(context.api), retry: false });
    await followUserLocale(context.i18n, me.user.locale);
  },
  pendingComponent: PageLoading,
  component: AppShell,
});
